var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.498,
    height: 52.498,
    viewBox: "0 0 52.498 52.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86256",
    "data-name": "Group 86256",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86261",
    "data-name": "Group 86261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242485",
    "data-name": "Path 242485",
    d: "M18.561,0A18.561,18.561,0,1,0,37.122,18.561,18.582,18.582,0,0,0,18.561,0m0,34.247A15.686,15.686,0,1,1,34.247,18.561,15.7,15.7,0,0,1,18.561,34.247",
    transform: "translate(0 26.25) rotate(-45)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242486",
    "data-name": "Path 242486",
    d: "M15.816,7.189h-5.75V1.438a1.438,1.438,0,1,0-2.877,0v5.75H1.438a1.438,1.438,0,1,0,0,2.875h5.75v5.752a1.438,1.438,0,0,0,2.877,0V10.064h5.75a1.438,1.438,0,1,0,0-2.875Z",
    transform: "translate(13.958 26.16) rotate(-45)",
    fill: "#a8a8aa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.d4ae38da03bf09849e7045f0896caf84.svg";
export { ForwardRef as ReactComponent };